<template>
  <div>
    <ol class="breadcrumb" style="border-radius:0" >
      <li class="breadcrumb-item">
        <router-link v-bind:to="'/' + $i18n.locale + '/' + property.slug + '/' + $t('reports.url')">
          {{$t('reports.name')}}
        </router-link>
      </li>
      <li class="breadcrumb-item" aria-current="page">{{$t('unitsSold')}}</li>
    </ol>
    <div class="container-fluid">
      <header class="page header">
        <div class="content">
          <h1 class="display-4 mb-0 mt-4">
            {{$t('unitsSold')}}
            -
            {{monthName}}
            {{year}}
          </h1>
          <p class="lead text-muted">
            {{$t('unitsSold')}}
            {{$t('forProperty')}}
            {{this.property.name}}
          </p>
        </div>
      </header>
      <div class="content">
        <div class="row">
          <div class="col-md-6 border-right">
            <ValidationObserver v-slot="{ handleSubmit }" ref="form">
              <form id="reportForm">
                <h5>Report Information</h5>
                <Values v-bind.sync="{values: report.values}"></Values>
                <div class="d-flex w-100">

                  <div class="btn-group btn-group-justified d-flex w-100 pb-5 pt-4">
                    <button type="button" name="save" class="btn btn-primary flex-grow-1" @click="handleSubmit(submit)">
                      {{ $t('submit') }}
                    </button>
                  </div>

                </div>
              </form>
            </ValidationObserver>
          </div>

          <div class="col-md-6">
            <h5>eTurizem</h5>
            <eTurizem v-bind.sync="{report: report.eTurizem}"></eTurizem>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Values from './components/Values';
import eTurizem from './components/eTurizem';

import moment from 'moment';

export default {
  name: 'CreateReport',
  components: {
     Values, eTurizem
  },
  props: ['socket'],
  beforeRouteEnter(to, from, next) {
    next(vm => {
      if(from.name){
        vm.from = from.fullPath
      }else{
        vm.from = '/' + to.params.property + '/calendar'
      }
    });
  },
  data: () => ({
    report: {
      values: {},
      eTurizem: {}
    },
    from: null,
    property: {
      rooms: []
    },
  }),
  computed: {
    monthName: function(){
      if(!this.month) return '';
      return moment(this.month, 'MM').locale(this.$i18n.locale).format('MMMM');
    }
  },
  created(){
    this.property = this.$store.state.host.properties.find(p => p.slug == this.$route.params.property);
    this.year = this.$route.params.year;
    this.month = this.$route.params.month;

    fetch(process.env.VUE_APP_API + '/properties/' + this.property._id + '/reports/' + this.year + '/' + this.month, {
      method: 'get',
      credentials: 'include',
      headers: {
        "Content-type": "application/json",
        "Accept": "application/json",
        "Accept-Charset": "utf-8",
        'CSRF-Token': this.$csrf
      }
    })
    .then(response => {
      return response.json();
    })
    .then(response => {
      this.report = response;
    })
  },
  methods: {

    submit: function(status = null){
      return fetch( process.env.VUE_APP_API + '/properties/' + this.property._id + '/reports/' + this.year + '/' + this.month, {
        method : 'post',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'CSRF-Token': this.$csrf
        },
        body: JSON.stringify({
          values: this.report.values,
          socket: {
            id: this.socket.id
          }
        })
      })
      .then(response => response.json())
      .then(response => {
        if(!response.error){
          console.log(response)
          this.report.eTurizem = response.mesecnoPorocilo;
          //this.$router.push(this.from);
        }else{
          console.log(response.error);
          this.$refs.form.setErrors(response.error.messages);
        }
      });
    }
  }
}
</script>

<i18n>
{
  "en": {
    "reports": {
      "name": "Reports",
      "url": "reports"
    },
    "unitsSold": "Units Sold",
    "forProperty": "for property",
    "submit": "Submit Report"
  },
  "sl": {
    "reports": {
      "name": "Poročila",
      "url": "porocila"
    },
    "unitsSold": "Prodane enote",
    "forProperty": "nastanitve",
    "submit": "Oddaj poročilo"
  }
}
</i18n>
